import background4 from "../../assets/home/background4.png";
import background3 from "../../assets/home/background3.png";
import PopularTours from "../../components/PopularTours/PopularTours";
import HotelSection from "../../components/HotelSection/HotelSection";
import Button from "../../components/Button/Button";
import "./Home.css";

function Home() {
  return (
    <>
      {/* Hero Section */}
      <section className="hero-section">
        {/* Left Image Section */}
        <div className="hero-left">
          <div className="hero-text">
            <h1>BEYOND</h1>
            <h6>TRAVEL, REFINED TO PERFECTION.</h6>
          </div>
        </div>
        {/* Right Image Section */}
        <div className="hero-right">
          <div className="hero-text right-text">
            <h1>
              ESCAPE
              <br />
              THE
              <br />
              KNOWN
            </h1>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <PopularTours />

      {/* Content */}
      <section
        className="experience-section"
        style={{ backgroundImage: `url(${background3})` }}
      >
        <div className="experience-overlay">
          <div className="experience-content">
            <h3>
              FOR US
              <br />
              QUALITY OF
              <br />
              EXPERIENCE
              <br />
              IS ONLY
              <br />
              SECOND TO
              <br />
              SAFETY.
            </h3>
            <Button buttonName="CONTACT WITH US" theme="light" to="/contact" />
          </div>
        </div>
      </section>

      {/* Hotel Section */}
      <HotelSection />

      <section
        className="about-section"
        style={{ backgroundImage: `url(${background4})` }}
      >
        <div className="about-content">
          <h2>THE KIND OF TRAVEL THAT STAYS WITH YOU</h2>
          <p>
            At Mystique Realm Travel, every detail is considered—from the
            sun-drenched hotel balcony to the café where the owner still writes
            the menu by hand. But the real magic? That’s in the unexpected: a
            jazz trio in a hidden square, the perfect bookshop stumble, a
            fisherman offering the freshest fish of your life.
          </p>
          <Button buttonName="ABOUT US" theme="light" to="/about" />
        </div>
      </section>
    </>
  );
}

export default Home;
